export var getHorizontalPosition = function (alignment, line) {
    var x;
    var x1 = line.x1, x2 = line.x2;
    switch (alignment) {
        case 'left':
            x = x1;
            break;
        case 'right':
            x = x2;
            break;
        default:
            x = x1 + (x2 - x1) / 2;
    }
    return x;
};
export var getVerticalPosition = function (alignment, line) {
    var y;
    var y1 = line.y1, y2 = line.y2;
    switch (alignment) {
        case 'top':
            y = -y2;
            break;
        case 'bottom':
            y = -y1;
            break;
        default:
            y = -(y1 + (y2 - y1) / 2);
    }
    return y;
};
export var getTextAnchor = function (alignment) {
    var textAnchor;
    switch (alignment) {
        case 'left':
        case 'bottom':
            textAnchor = 'start';
            break;
        case 'right':
        case 'top':
            textAnchor = 'end';
            break;
        default:
            textAnchor = 'middle';
    }
    return textAnchor;
};
